// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeERC721DepositCalls = exports.makeERC20DepositCalls = exports.makeETHDepositCalls = void 0;
const ethers_1 = require("ethers");
const ETHHolder__factory_1 = require("./contracts/factories/ETHHolder__factory");
const IERC20__factory_1 = require("./contracts/factories/IERC20__factory");
const IERC721__factory_1 = require("./contracts/factories/IERC721__factory");
const ERC20Holder__factory_1 = require("./contracts/factories/ERC20Holder__factory");
const ERC721Holder__factory_1 = require("./contracts/factories/ERC721Holder__factory");
const assets_1 = require("../assets");
const assets_2 = require("../assets");
function makeETHDepositCalls(signer, holderAddr, _, amount) {
    if (!(amount instanceof assets_1.Amount)) {
        throw new Error("given value is not of type Amount");
    }
    const holder = ETHHolder__factory_1.ETHHolder__factory.connect(holderAddr.toString(), signer);
    return [
        [
            "deposit",
            (obj) => {
                const combinedOverride = {
                    ...{ value: ethers_1.BigNumber.from(amount.value) },
                    ...obj,
                };
                return holder.deposit(combinedOverride);
            },
        ],
    ];
}
exports.makeETHDepositCalls = makeETHDepositCalls;
function makeERC20DepositCalls(signer, holderAddr, tokenAddr, amount) {
    if (!(amount instanceof assets_1.Amount)) {
        throw new Error("given value is not of type Amount");
    }
    const token = IERC20__factory_1.IERC20__factory.connect(tokenAddr.toString(), signer);
    const holder = ERC20Holder__factory_1.ERC20Holder__factory.connect(holderAddr.toString(), signer);
    return [
        [
            "approve",
            (obj) => {
                return token.approve(holderAddr.toString(), ethers_1.BigNumber.from(amount.value), obj);
            },
        ],
        [
            "deposit",
            (obj) => {
                return holder.deposit(tokenAddr.toString(), ethers_1.BigNumber.from(amount.value), obj);
            },
        ],
    ];
}
exports.makeERC20DepositCalls = makeERC20DepositCalls;
function makeERC721DepositCalls(signer, holderAddr, tokenAddr, amount) {
    if (!(amount instanceof assets_2.Tokens)) {
        throw new Error("given value is not of type Tokens");
    }
    const token = IERC721__factory_1.IERC721__factory.connect(tokenAddr.toString(), signer);
    const holder = ERC721Holder__factory_1.ERC721Holder__factory.connect(holderAddr.toString(), signer);
    const calls = [];
    for (const id of amount.value) {
        calls.push([
            "approve",
            (obj) => {
                return token.approve(holderAddr.toString(), ethers_1.BigNumber.from(id), obj);
            },
        ]);
    }
    calls.push([
        "deposit",
        (obj) => {
            return holder.deposit(tokenAddr.toString(), amount.value.map(ethers_1.BigNumber.from), obj);
        },
    ]);
    return calls;
}
exports.makeERC721DepositCalls = makeERC721DepositCalls;
//# sourceMappingURL=contracts_deposit.js.map